"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@repo/design-system/hooks/use-filter";
import type { FilterValue } from "@repo/design-system/types/filter";
import type { GroupedOption, Option } from "@repo/design-system/types/filtermenu";
import { useState } from "react";
import { Combobox, ComboboxContent, ComboboxControls, ComboboxEmpty, ComboboxFloatingLabel, ComboboxInput, ComboboxInputGroup, ComboboxItem, ComboboxList, ComboboxSeparator } from "~/components/ui/combobox-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { MultiSelectProps } from "./multi-select";
import { OptionDisplay } from "./select-layout-eon";
export function GroupSelect(t0) {
  const $ = _c(44);
  const {
    filterBy,
    id,
    label
  } = t0;
  const t = useLanguage();
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== filterBy) {
    t1 = {
      filterTypes: filterBy
    };
    $[0] = filterBy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    clearFilter,
    toggleFilter,
    activeFilters,
    options
  } = useFilter(t1);
  const hasValue = activeFilters.length > 0;
  const floating = open;
  const groupedOptions = options as GroupedOption[];
  let t2;
  if ($[2] !== groupedOptions) {
    t2 = groupedOptions.flatMap(_temp);
    $[2] = groupedOptions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const flatOptions = t2;
  const secondGroupFirstOptionValue = groupedOptions[1]?.options[0]?.value;
  let t3;
  if ($[4] !== activeFilters || $[5] !== toggleFilter) {
    t3 = async newSelection => {
      const currentSet = new Set(activeFilters.map(_temp2));
      const newSet = new Set(newSelection.map(_temp3));
      const added = newSelection.find(f_1 => !currentSet.has(f_1.value));
      const removed = activeFilters.find(f_2 => !newSet.has(f_2.value));
      const changed = added ?? removed;
      if (changed) {
        await toggleFilter(changed.value as FilterValue);
      }
    };
    $[4] = activeFilters;
    $[5] = toggleFilter;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleValueChange = t3;
  let t4;
  if ($[7] !== floating || $[8] !== id || $[9] !== label) {
    t4 = <ComboboxFloatingLabel floating={floating} htmlFor={id}>{label}</ComboboxFloatingLabel>;
    $[7] = floating;
    $[8] = id;
    $[9] = label;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = floating ? t.filterbar_filter1_placeholder_search : "";
  let t6;
  if ($[11] !== id || $[12] !== t5) {
    t6 = <ComboboxInput id={id} placeholder={t5} />;
    $[11] = id;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== activeFilters || $[15] !== hasValue) {
    t7 = hasValue && <OptionDisplay activeFilters={activeFilters} />;
    $[14] = activeFilters;
    $[15] = hasValue;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== clearFilter || $[18] !== hasValue || $[19] !== label || $[20] !== open) {
    t8 = <ComboboxControls hasValue={hasValue} label={label} onClear={clearFilter} open={open} />;
    $[17] = clearFilter;
    $[18] = hasValue;
    $[19] = label;
    $[20] = open;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== open || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <ComboboxInputGroup open={open}>{t6}{t7}{t8}</ComboboxInputGroup>;
    $[22] = open;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t.filtermenu_noOptions) {
    t10 = <ComboboxEmpty>{t.filtermenu_noOptions}</ComboboxEmpty>;
    $[27] = t.filtermenu_noOptions;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== secondGroupFirstOptionValue) {
    t11 = <ComboboxList>{item => <>{item.value === secondGroupFirstOptionValue ? <ComboboxSeparator className="mx-0 my-1" /> : null}<ComboboxItem key={item.value} value={item}><span>{item.label}</span><span>{item.count}</span></ComboboxItem></>}</ComboboxList>;
    $[29] = secondGroupFirstOptionValue;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11) {
    t12 = <ComboboxContent>{t10}{t11}</ComboboxContent>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== activeFilters || $[35] !== flatOptions || $[36] !== handleValueChange || $[37] !== open || $[38] !== t12 || $[39] !== t9) {
    t13 = <Combobox isItemEqualToValue={_temp4} items={flatOptions} itemToStringLabel={_temp5} multiple={true} onOpenChange={setOpen} onValueChange={handleValueChange} open={open} value={activeFilters}>{t9}{t12}</Combobox>;
    $[34] = activeFilters;
    $[35] = flatOptions;
    $[36] = handleValueChange;
    $[37] = open;
    $[38] = t12;
    $[39] = t9;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t13 || $[42] !== t4) {
    t14 = <div className="relative">{t4}{t13}</div>;
    $[41] = t13;
    $[42] = t4;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
}
function _temp5(opt) {
  return opt.label;
}
function _temp4(a, b) {
  return a.value === b.value;
}
function _temp3(f_0) {
  return f_0.value;
}
function _temp2(f) {
  return f.value;
}
function _temp(g) {
  return g.options;
}